import {Link, Navigate, useLocation, useNavigate, useOutletContext, useParams, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import { Client } from '../Api/Client';
import closeIcon from '../assets/icons/close.png';
import searchIcon from '../assets/icons/search-dark.png';
import {mapRoutesSvToEn, mapRoutesEnToSv} from "../Utils/routes";

export function highlight(entry:string, search: string) {
    if (!search.length) {
        return entry;
    }
    const regExp = new RegExp(search, 'gi');
    return entry.replaceAll(regExp, (str) =>  '<b class="border-b border-b-rose">' + str + '</b>');
}

function SearchListPage() {
    const params = useParams();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const [listItems, setListItems] = useState<any>([]);
    const [texts, setTexts] = useState<any>([]);
    const [search, setSearch] = useState('');

    const location = useLocation();
    useEffect(() => {
        window.scrollTo({top: 0, left: 0});
    }, [location]);

    async function getPageData (signal: any) {
        Client.get(`/pages/search/${mapRoutesSvToEn(params.type ?? '')}`, {signal})
            .then((response) => {
                setListItems(response.data.listItems ?? []);
                setTexts(response.data.texts ?? []);
            })
            .catch((e) => console.log(e.message))
    }

    useEffect(() => {
        const abortController = new AbortController();
        getPageData(abortController.signal);

        return () => abortController.abort();
    }, []);

    useEffect(() => {
        if (searchParams.has('query')) {
            const query = searchParams.get('query');
            query?.length && setSearch(query);
        }
    }, []);

    function searchTextHandler(event:  any) {
        const value = event.target.value;
        setSearch(value);
    }

    return (
        <div className="absolute top-0 left-0 z-20 w-full min-h-full bg-grey-900 text-grey-100 py-6 px-4">
            <div className="sticky top-0 left-0 w-full bg-grey-900 py-4 xl:mx-auto xl:w-auto xl:max-w-[60rem]">
                <button className="absolute top-0 right-0 z-20 py-4 ps-4" onClick={() => navigate(-1)}>
                    <img src={closeIcon} width={24} height={24} alt="Close"/>
                </button>
                <h2 className="font-sweing font-medium text-3xl mb-4">{texts.title}</h2>
                <div className="relative">
                    <input type="text" value={search} onChange={searchTextHandler} className="w-full p-4 pe-12 rounded bg-grey-300 font-body text-lg text-grey-900 focus:outline-none" placeholder={texts.placeholder}/>
                    <img src={searchIcon} width={24} height={24} alt="Search" className="absolute top-1/2 -translate-y-1/2 right-4" />
                </div>
            </div>
            <div className="w-full xl:mx-auto xl:w-auto xl:max-w-[60rem]">
                <p className="text-body text-sm uppercase pt-8 pb-2.5 px-4 text-grey-500">{search.length ? texts.filledTag : texts.tag}</p>
                {Object.keys(listItems).map((key, index) =>
                    {
                        const url = `/${mapRoutesEnToSv(listItems[key].type)}/${listItems[key].id}/${listItems[key].slug}`;
                        const item = listItems[key];
                        const nameMatches = item.name.toLowerCase().includes(search.toLowerCase());

                        let matchedRelatedTitles: string[] = [];
                        if (search.length > 0 && item.related_titles) {
                            matchedRelatedTitles = item.related_titles.filter((title: string) =>
                                title.toLowerCase().includes(search.toLowerCase())
                            );
                        }

                        if (nameMatches || matchedRelatedTitles.length > 0) {
                            return <div key={index} className="px-4 py-6 text-lg leading-5 border-b border-grey-700">
                                <Link to={url}>
                                    <span dangerouslySetInnerHTML={{__html: highlight(item.name, search)}} />
                                    {matchedRelatedTitles.length > 0 && (
                                        <p className="text-sm text-grey-400 mt-1" dangerouslySetInnerHTML={{__html: highlight(matchedRelatedTitles.join(', '), search)}} />
                                    )}
                                </Link>
                            </div>
                        }
                    }
                )}
            </div>
        </div>
    );
}

export default SearchListPage;